"use client";
import NativeSelect from "@casino/legacyUi/NativeSelect";
import useLanguageSwitcher from "./useLanguageSwitcher";

const languageCodeToTitleMapper: Record<LanguageCode, string> = {
  ar: "العربية",
  de: "Deutsch",
  en: "English",
  es: "Español",
  fi: "Suomi",
  fr: "Français",
  id: "Bahasa Indonesia",
  ja: "日本語",
  ko: "한국어",
  no: "Norsk",
  pt: "Português",
  th: "ไทย",
  tr: "Türkçe",
  vi: "Tiếng Việt",
  zh: "中文",
};

type Props = {
  currentLanguage: string;
  isLoggedIn: boolean;
  defaultLang: string;
  languages: LanguageCode[];
  languageFeatureFlags: Partial<Record<LanguageCode, boolean>>;
  languageSelectTextColor?: string;
};

const LanguageSwitcher: FC<Props> = ({
  currentLanguage,
  isLoggedIn,
  defaultLang,
  languages,
  languageFeatureFlags,
  languageSelectTextColor,
}) => {
  const { handleChange } = useLanguageSwitcher({
    isLoggedIn,
    defaultLang,
    languages,
    languageFeatureFlags,
  });

  const filteredLanguages = languages.filter(
    (lang) => languageFeatureFlags[lang] !== false,
  );

  return (
    <NativeSelect
      className="[&_select]:text-muted-foreground [&_select]:bg-background"
      data-testid="language-switcher"
      value={currentLanguage}
      languageSelectTextColor={languageSelectTextColor}
      onChange={(e) => handleChange(e.target.value)}
    >
      {languageCodeToTitleMapper[currentLanguage as LanguageCode]}
      {filteredLanguages.map((code) => (
        <option value={code} key={code}>
          {languageCodeToTitleMapper[code]}
        </option>
      ))}
    </NativeSelect>
  );
};

export default LanguageSwitcher;
